import { Stack, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { type ComponentPropsWithoutRef } from "react";
import z from "zod";
import { TabsComponent } from "@/components/core/tabs-component";
import { ReportTable } from "@/components/reports/report-table";
import { ReportableEntity } from "@/models/backend";

const tabs = ["customer", "invoice", "event"] as const;

const searchSchema = z.object({
  tab: z.enum(tabs).default("customer").catch("customer"),
});

export const Route = createFileRoute("/_authenticated/_contained/reports/")({
  component: RouteComponent,
  validateSearch: searchSchema,
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();

  const tabObjs: (ComponentPropsWithoutRef<typeof TabsComponent>["tabs"][number] & {
    id: (typeof tabs)[number];
  })[] = [
    {
      id: "customer",
      label: "Customers",
      component: <ReportTable entity={ReportableEntity.customer} />,
    },
    {
      id: "invoice",
      label: "Invoices",
      component: <ReportTable entity={ReportableEntity.invoice} />,
    },
    {
      id: "event",
      label: "Activity",
      component: <ReportTable entity={ReportableEntity.event} />,
    },
  ];

  return (
    <Stack spacing={2}>
      <Typography variant="h3">Reports</Typography>
      <TabsComponent
        tabs={tabObjs}
        selectedTab={tabObjs.findIndex((tabObj) => tabObj.id === tab)}
        onSelectedTab={(idx) => {
          navigate({ search: { tab: tabObjs[idx].id } });
        }}
      />
    </Stack>
  );
}
